enum StorageProvider {
  GOOGLE_DRIVE = "google_drive",
  ONEDRIVE = "onedrive",
  S3 = "s3",
  SHAREPOINT = "sharepoint",
}

export default StorageProvider;
